"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BASE_CND: ()=>BASE_CND,
    IMPLEMENTATION_ENDPOINTS: ()=>IMPLEMENTATION_ENDPOINTS
});
const BASE_CND = 'https://s1.pclncdn.com';
const IMPLEMENTATION_ENDPOINTS = {
    DRIVE: '/genai-svc/genai/chat/st/rcListings',
    STAYDETAILS: '/genai-svc/genai/chat/st/hotelDetail',
    STAYLISTINGS: '/genai-svc/genai/chat/st/hotelListings',
    FLYDETAILS: '/genai-svc/genai/chat/st/flightDetail',
    FLYLISTINGS: '/genai-svc/genai/chat/st/flightListings',
    PACKAGE: '/genai-svc/genai/chat/st/package',
    ITINERARY: '/genai-svc/genai/chat/st/travelItinerary',
    LANDING: '/genai-svc/genai/chat/st/homePageSearch',
    CHECKOUT: '/genai-svc/genai/chat/st/checkout',
    PORTAL: '/genai-svc/genai/chat/pennyPortal'
};
exports.BASE_CND = __webpack_exports__.BASE_CND;
exports.IMPLEMENTATION_ENDPOINTS = __webpack_exports__.IMPLEMENTATION_ENDPOINTS;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BASE_CND",
    "IMPLEMENTATION_ENDPOINTS"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
